import React from "react";
import useRouterContext from "../../hooks/useRouterContext";
import PathVariables from "../../libs/router/PathVariables";
import { RouterFactory } from "../../libs/router/Router";
export default function Routes(props) {
    const [state] = useRouterContext();
    const isCurrentPage = RouterFactory.isCurrentPage(state);
    let variables = {};
    const page = React.Children.toArray(props.children).find((item) => {
        const [matches, pathVariables] = isCurrentPage(item);
        if (matches)
            variables = pathVariables;
        return matches;
    });
    return (React.createElement(PathVariables.Provider, { value: variables }, page));
}
